
import { defineComponent } from "vue";

export default defineComponent({
  name: "sys-cofig",
});
